import { CoreStringValueBuilderPart } from "./CoreModels";

export enum EntraIdUserExportUserType {
    UNDEFINED = 0,
    STUDENT = 1,
    STAFF = 2,
}

export enum EntraIdUserExportCompanyNameSource {
    NONE = 0,
    PRIMARY_SCHOOL_UNIT_NAME = 1,
    CONSTANT_VALUE = 2,
}

export enum EntraIdUserExportExtensionsSource {
    None = 0x0000,
    CivicNo = 0x0001,
    Eppn = 0x0002,
    UserExternalId = 0x0004,
}

export enum EntraIdUserExportDepartmentSource {
    NONE = 0,
    PRIMARY_SCHOOL_UNIT_NAME = 1,
    CONSTANT_VALUE = 2,
}

export enum EntraIdUserExportEmployeeIdSource {
    NONE = 0,
    CIVIC_NO = 1
}

export enum EntraIdUserExportEmployeeTypeSource {
    NONE = 0,
    ROLE_BASED = 1,
}

export enum EntraIdUserExportJobTitleSource {
    NONE = 0,
    ROLE_BASED = 1,
}

export enum EntraIdUserExportUserPrincipalNameSource {
    None = 0,

    /** 
     * Använd e-postadress från FlowSync för den roll som ska synkas  
     */
    FLOW_SYNC_EMAIL_ADDRESS = 1,

    
    /** 
     * Använd ett värde genererat av det s.k block systemet.
     */
    GENERATED = 2,
}

export enum EntraIdUserExportPrimaryEmailAddressSource {
    
    None = 0,

    /** 
     * Använd e-postadress från FlowSync för den roll som ska synkas  
     */
    FLOW_SYNC_EMAIL_ADDRESS = 1,

    /** 
     * Använd samma värde som kommer skickas för fältet User Principal Name
     */
    COPY_USER_PRINCIPAL_NAME = 2,

    /** 
     * Använd ett värde genererat av det s.k block systemet.
     */
    GENERATED = 3,
}

export enum EntraIdUserExportAliasHandling {
    NONE = 0,
    SET_OLD_AS_ALIAS = 1,
    SET_NEW_AS_ALIAS = 2,
}

export enum EntraIdUserExportSettingBehaviour {
    UNDEFINED = 0,
    SET_ONCE = 1,
    FORCE = 2,
    ALLOW_CHANGE = 3
}

export enum EntraIdUserExportPasswordSettingType {
    /**
     * This value is invalid and will result in errors
     */
    NONE = 0,

    /**
     * Use a chosen specific value as password on new users
     */
    STATIC = 1,

    /**
     *  Generate a unique password for each new user
     */ 
    RANDOM = 2,
}

export enum EntraIdUserExportPasswordCharacterSet {
    
    /**
     * Invalid when policy is set to Generate
     */
    NONE = 0x00000000,

    /**
     * A-Z - Versaler
     */
    UPPER_CASE_LETTERS = 0x00000001,

    /**
     * a-z - Gemener
     */
    LOWER_CASE_LETTERS = 0x00000002,

    /**
     * 0-9 - Siffror
     */
    NUMBERS = 0x00000004,

    /**
     * !"#&/()=? - Specialtecken
     */
    SPECIAL_CHARACTERS = 0x00000008,

    /**
     * Alla
     */
    All = 0x7FFFFFFF,
}

export interface CoreEntraIdUserExportUserPrincipalNameSettings {
    source: EntraIdUserExportUserPrincipalNameSource
    forceDomainName: boolean
    forceDomainNameValue?: string
    settingBehaviour: EntraIdUserExportSettingBehaviour
    stringValueBuilderParts: CoreStringValueBuilderPart[]
}

export interface CoreEntraIdUserExportPrimaryEmailAddressSettings {
    source: EntraIdUserExportPrimaryEmailAddressSource
    forceDomainName: boolean
    forceDomainNameValue?: string
    settingBehaviour: EntraIdUserExportSettingBehaviour
    stringValueBuilderParts: CoreStringValueBuilderPart[]
    aliasHandling: EntraIdUserExportAliasHandling
}

export interface CoreEntraIdUserExportPasswordSettings {
    type: EntraIdUserExportPasswordSettingType
    forcePasswordChangeOnNextLogin: boolean
    staticValue: string
    useMonthAndDayFromSocialnumber: boolean
    minLength: number 
    maxLength: number
    passwordCharacterSets: EntraIdUserExportPasswordCharacterSet
}

export interface CoreEntraIdUserExportConfiguration {
    id: string
    synchronizedUserType: EntraIdUserExportUserType
    companyNameSource: EntraIdUserExportCompanyNameSource
    companyNameConstant?: string
    departmentSource: EntraIdUserExportDepartmentSource
    departmentConstant?: string
    employeeIdSource: EntraIdUserExportEmployeeIdSource
    employeeIdSourceName?: string
    employeeTypeSource: EntraIdUserExportEmployeeTypeSource
    jobTitleSource: EntraIdUserExportJobTitleSource
    exportAddress: boolean
    extensionsSource: EntraIdUserExportExtensionsSource
    reportRecipients: string[]
    archiveGracePeriod: number | null
    deleteGracePeriod: number | null
    userPrincipalNameSettings: CoreEntraIdUserExportUserPrincipalNameSettings
    primaryEmailAddressSettings: CoreEntraIdUserExportPrimaryEmailAddressSettings
    passwordSettings: CoreEntraIdUserExportPasswordSettings
}